export function isValidEmail(email) {
  const trimmedEmail = email.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
}

export function sanitiseFilename(filename) {
  return filename.replace(/[\/\\:*?"<>|]/g, '_');
}

export function truncate(str, maxLength) {
  return str.trim().slice(0, maxLength);
}
